import { BaseModel } from 'src/app/shared/models/base.model';

export class Color extends BaseModel{
    static fromJsonToObject(jsonData:any):Color{
        return Object.assign(new Color(),jsonData);
    }
}